import React from 'react';

export interface StatsCardStat {
  label: string;
  value: string | number;
  colorClass?: string;
}

interface StatsCardProps {
  title: string;
  stats: StatsCardStat[];
}

const StatsCard: React.FC<StatsCardProps> = ({ title, stats }) => (
  <div className="bg-white shadow rounded-lg p-6 min-w-[220px] flex flex-col items-center justify-center">
    <h4 className="text-md font-semibold mb-2">{title}</h4>
    <div className="flex flex-col gap-2 w-full">
      {stats.map((stat, idx) => (
        <div key={idx} className="flex justify-between w-full">
          <span className={stat.colorClass ? `${stat.colorClass} font-medium` : 'font-medium'}>{stat.label}</span>
          <span className="font-bold">{stat.value}</span>
        </div>
      ))}
    </div>
  </div>
);

export default StatsCard;
